import CategoryWeightsWarningModal from "pages/ManagementPage/CategoryWeightsWarningModal/CategoryWeightsWarningModal";

export default CategoryWeightsWarningModal;
